// Reine Regeln der Lauf-Karte — getestet (run-helpers.test.ts).

import type { RunStep } from "../../api/types";

/** Was rechts neben einem Schritt steht: Dauer, „läuft", „übersprungen" oder nichts. */
export function stepDuration(s: RunStep): string {
  if (s.finished_at && s.started_at) {
    return `${Math.max(0, Math.round((Date.parse(s.finished_at) - Date.parse(s.started_at)) / 1000))} s`;
  }
  if (s.state === "running") return "läuft";
  if (s.state === "skipped") return "übersprungen";
  return "";
}

/** Der Schritt, dessen Protokoll offen steht: der laufende oder der gescheiterte (−1: keiner). */
export function openStepIndex(steps: RunStep[]): number {
  return steps.findIndex((s) => s.state === "running" || s.state === "failed");
}
